import { Box } from "@mui/material";
import { Formik, FormikProps } from "formik";
import React, { useState } from "react";
import { UserProviderProfile } from "../../recoil/types";
import { formatPhoneNumber } from "../../utils/helpers";
import { Button } from "../shared/Button/Button";
import { SpinnerLoading } from "../shared/Spinner/SpinnerLoading";
import FormField from "../shared/TextField/FormField";
import {
  EditReport,
  FieldRow,
  GeneralInfoText,
  GeneralInfoWrapper,
} from "./Profile.styles";
import {
  UpdateProfile,
  updateProfileInitialValues,
  UpdateProfileRequestType,
} from "./Services/UpdateProfileInfoService";
import { useAuthenticationHook } from "../../utils/hooks/useAuthenticationHook";

const ProfileDetails: React.FC<{ profileInfo: UserProviderProfile }> = ({
  profileInfo,
}) => {
  const { auth, setLoggedOut } = useAuthenticationHook();
  const [profile, setProfileInfo] = useState(profileInfo);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <div>
      {!loading ? (
        <Formik<UpdateProfileRequestType>
          initialValues={{
            ...updateProfileInitialValues,
          }}
          onSubmit={async (values, { resetForm }) => {
            setLoading(true);
            try {
              const response = await UpdateProfile(
                auth!.token,
                {
                  ...values,
                },
                setLoggedOut,
              );
              setLoading(false);
              if (response?.ok) {
                const newProfile = await response.json();
                setProfileInfo(newProfile);
                resetForm();
              } else {
                // setResponseMessage("There was an error - please try again.");
              }
            } catch (e) {
              setLoading(false);
              // setResponseMessage(networkErrorMessage);
            }
          }}
          validateOnChange={false}
        >
          {({
            values,
            handleSubmit,
            setFieldValue,
            resetForm,
          }: FormikProps<UpdateProfileRequestType>) => (
            <GeneralInfoWrapper>
              <GeneralInfoText>MY PROFILE</GeneralInfoText>
              <FieldRow>
                <FormField
                  styles={{ borderTop: "1px solid #e7ebf2" }}
                  fieldTitle="First Name"
                  fieldValue={values.first_name || profile.profile.first_name}
                  onFieldChange={(val) => setFieldValue("first_name", val)}
                  edit={editMode}
                />
                <FormField
                  styles={{ borderTop: "1px solid #e7ebf2" }}
                  fieldTitle="Last Name"
                  fieldValue={values.last_name || profile.profile.last_name}
                  onFieldChange={(val) => setFieldValue("last_name", val)}
                  edit={editMode}
                />
              </FieldRow>
              <FieldRow>
                <FormField
                  fieldTitle="Email"
                  fieldValue={profile.profile.email}
                />
                <FormField
                  fieldTitle="Address"
                  fieldValue={
                    profile.profile.contact.mailingstreet
                      ? `${profile.profile.contact.mailingstreet}, ${profile.profile.contact.mailingstate} ${profile.profile.contact.mailingpostalcode}`
                      : ""
                  }
                />
              </FieldRow>
              <FieldRow>
                <FormField
                  fieldTitle="Phone number"
                  fieldValue={
                    formatPhoneNumber(profile.profile.contact.phone || "") ||
                    "-"
                  }
                />
                <FormField
                  fieldTitle="Mobile Number"
                  fieldValue={
                    formatPhoneNumber(profile.profile.contact.phone || "") ||
                    "-"
                  }
                />
              </FieldRow>
              <EditReport>
                {!editMode && (
                  <Button
                    label="EDIT"
                    onClick={() => setEditMode(true)}
                    size="medium"
                    reverse
                  />
                )}
                {editMode && (
                  <Box sx={{ display: "flex", gap: "15px" }}>
                    <Button
                      label="SAVE"
                      onClick={() => {
                        handleSubmit();
                        setEditMode(false);
                      }}
                      size="medium"
                    />
                    <Button
                      label="CANCEL"
                      onClick={() => {
                        setEditMode(false);
                        resetForm();
                      }}
                      size="medium"
                      reverse
                    />
                  </Box>
                )}
              </EditReport>
            </GeneralInfoWrapper>
          )}
        </Formik>
      ) : (
        <div
          style={{
            height: "100%",
            width: "100%",
            paddingBottom: "100px",
          }}
        >
          <SpinnerLoading />
        </div>
      )}
    </div>
  );
};

export default ProfileDetails;
